import { useMutation } from "@tanstack/react-query";
import { getRebuildAPI } from "@rebuild/shared/api";
import type { ExportPhotoReportBody } from "@rebuild/shared/models";

const EXPORT_PHOTO_REPORT_KEY = ["pdfExport", "photoReport"] as const;

const { estimatesControllerExportPhotoReport } = getRebuildAPI();

export function useExportPhotoReportMutation() {
  return useMutation({
    mutationKey: EXPORT_PHOTO_REPORT_KEY,
    // The endpoint streams PDF bytes; the generated client types it as `void`, so ask axios for an
    // ArrayBuffer and surface that to the caller.
    mutationFn: async (params: { estimateId: string; body: ExportPhotoReportBody }): Promise<ArrayBuffer> => {
      const bytes = await estimatesControllerExportPhotoReport(params.estimateId, params.body, { responseType: "arraybuffer" });
      return bytes as unknown as ArrayBuffer;
    },
  });
}
